import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './detail-panel.css';

function MenuItemContent({ icon, title, subtitle }) {
  return (
    <div className="add-action-menu-item">
      {icon ? <span className="add-action-menu-item-icon">{icon}</span> : null}
      <div className="add-action-menu-item-text">
        <div className="add-action-menu-item-title">{title}</div>
        {subtitle ? (
          <div className="add-action-menu-item-subtitle">{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}

export default function AddActionDropdown({
  label = 'Add',
  icon,
  items = [],
  className = '',
  buttonProps = {},
}) {
  const menuItems = items.map((item) => ({
    key: item.key,
    label: (
      <MenuItemContent
        icon={item.icon}
        title={item.title}
        subtitle={item.subtitle}
      />
    ),
    disabled: item.disabled,
  }));

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: menuItems,
        onClick: ({ key, domEvent }) => {
          domEvent?.stopPropagation();
          const item = items.find((i) => i.key === key);
          item?.onClick?.();
        },
      }}
    >
      <Button
        type="primary"
        className={className}
        icon={icon}
        {...buttonProps}
      >
        {label}
        <DownOutlined style={{ fontSize: 10, marginLeft: 6 }} />
      </Button>
    </Dropdown>
  );
}
